import { createContext } from "react";
import type { CoreBus } from "../core/bus";
import type { RoomPeer } from "./peer-state";

export type RoomContextValue = {
  bus: CoreBus;
  roomId: string | null;
  peers: RoomPeer[];
  /** The randomly-generated, immutable presence name for this device. */
  generatedName: string;
  /** The user's chosen name (empty string ⇒ use generatedName). */
  editedName: string;
  createRoom: () => void;
  joinRoom: (roomId: string) => void;
  leaveRoom: () => void;
  copyLink: () => void;
  setEditedName: (name: string) => void;
};

export const RoomContext = createContext<RoomContextValue | null>(null);
